import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { Activate2FaRequest, Activate2FaResponse } from './2fa.types'

const activate2Fa = async (
  payload: Activate2FaRequest,
): Promise<Activate2FaResponse> => {
  const response = await apiClient.post<Activate2FaResponse>(
    '/v1/administration/user/2fa/activate',
    payload,
  )
  return response.data
}

export const useActivate2Fa = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (payload: Activate2FaRequest) => activate2Fa(payload),
    meta: {
      // 'user-account-context' carries userAccountInformation.has2FaEnabled,
      // which gates the account-wide 2FA enforcement modal
      invalidatesQuery: ['user-2fa-status', 'user-account-context'],
      ...feedback,
    },
  })
}
